export const DocumentModalIds = {
	CREATE_DOCUMENT: 'create-document-modal',
	IMPORT_DOCUMENT: 'import-document-modal',
	DETACH_DOCUMENT: 'detach-document-modal',
	MANAGE_DOCUMENT: 'manage-document-modal',
	HANDLE_DIVERGENT_DOCUMENT_VERSIONS: 'handle-divergent-document-versions-modal',
	HANDLE_DUPLICATE_DOCUMENT: 'handle-duplicate-document-modal',
	DIGITAL_SIGNATURE_DOCUMENT: 'digital-signature-modal'
};

export default DocumentModalIds;
